import * as React from "react";

const SvgComponent = ({ color, bg, stroke, ...props }) => (
  <svg width={30} height={30} fill={props.bgcolor} {...props}>
    <rect
      x={0.5}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bg}
      stroke={stroke}
    />
    <circle cx={15.5} cy={15.5} r={5.5} fill={bg} />
    <path
      d="M15.5 8a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm0 2.586c.286 0 .517.232.517.517v4.187l2.595 2.586a.522.522 0 0 1 0 .735.522.522 0 0 1-.736 0l-2.74-2.747a.512.512 0 0 1-.153-.364v-4.397c0-.285.231-.517.517-.517Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
